import { ZipControl } from 'site-modules/lease-deals/components/filters/controls/zip-control/zip-control';
import { StandardCheckboxControl } from 'site-modules/lease-deals/components/filters/controls/standard-checkbox-control/standard-checkbox-control';
import { PillCheckboxControl } from 'site-modules/lease-deals/components/filters/controls/pill-checkbox-control/pill-checkbox-control';
import { TrackedCheckboxControl } from 'site-modules/lease-deals/components/filters/controls/tracked-checkbox-control/tracked-checkbox-control';
import { PriceRangeControl } from 'site-modules/lease-deals/components/filters/controls/price-range-control/price-range-control';
import { SortControl } from 'site-modules/lease-deals/components/filters/controls/sort-control/sort-control';
import { SortHeaderControl } from 'site-modules/lease-deals/components/filters/controls/sort-header-control/sort-header-control';

export const FILTER_CONTROLS = {
  CHECKBOX_STANDARD: 'CHECKBOX_STANDARD',
  CHECKBOX_PILL: 'CHECKBOX_PILL',
  CHECKBOX_TRACKED: 'CHECKBOX_TRACKED',
  ZIP_INPUT: 'ZIP_INPUT',
  MONTHLY_PAYMENT: 'monthlyPayment',
  SORT_BY: 'SORT_BY',
  SORT_BY_HEADER: 'SORT_BY_HEADER',
};

export const CONTROL_COMPONENT_MAP = {
  [FILTER_CONTROLS.ZIP_INPUT]: ZipControl,
  [FILTER_CONTROLS.CHECKBOX_STANDARD]: StandardCheckboxControl,
  [FILTER_CONTROLS.CHECKBOX_PILL]: PillCheckboxControl,
  [FILTER_CONTROLS.CHECKBOX_TRACKED]: TrackedCheckboxControl,
  [FILTER_CONTROLS.MONTHLY_PAYMENT]: PriceRangeControl,
  [FILTER_CONTROLS.SORT_BY]: SortControl,
  [FILTER_CONTROLS.SORT_BY_HEADER]: SortHeaderControl,
};
